export default [
    {
        name: 'Pagamentos',
        url: '/gescon/financeiro/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-UFI-PAG-00'
    }
]
